module.exports = __webpack_public_path__ + "static/media/logo-digix-laranja.2c5432dc.svg";